<template>
  <aside
    :class="{ active: modelValue }"
    class="drawer fixed inset-0 bg-black bg-opacity-50 z-50"
  >
    <form
      class="drawer-content fixed right-0 inset-y-0 h-screen overflow-hidden w-full max-w-xl bg-white text-black"
      @submit.prevent="sendForm"
    >
      <input
        type="hidden"
        name="action"
        value="contact-form/send"
      />
      <input
        type="hidden"
        name="subject"
        :value="`Offerte aanvraag: ${product.title}`"
      />
      <input
        type="hidden"
        name="message[Productlink]"
        :value="product.url"
      />
      <template v-if="configuration?.steps">
        <input
          v-for="step in configuration.steps.filter((step) => step.value)"
          :key="`chosen-step-${step.id}`"
          type="hidden"
          :name="`message[${step.description}]`"
          :value="`${step.valueDescription} (${formatCurrency(step.possibleValues.find((value => value.key === step.value)).chargeAmount)})`"
        />
      </template>
      <button
        class="flex items-center group absolute top-0 right-0 p-20"
        type="button"
        @click="$emit('update:modelValue', false)"
      >
        <closeIcon class="rotate-45 group-hover:rotate-[135deg] transition" />
      </button>
      <div class="p-50 h-full overflow-y-auto">
        <h2
          v-if="data?.heading"
          class="wysiwyg-title text-3xl md:text-4xl lg:text-5xl xl:text-6xl"
          v-html="data?.heading"
        />
        <div
          v-if="data?.intro"
          class="mt-20 wysiwyg"
          v-html="data.intro"
        />

        <message :message="apiMessage" />

        <div class="relative mt-40">
          <input
            id="name"
            type="text"
            class="form-input"
            name="fromName"
            :placeholder="`${$t('interior-advice.name')} *`"
            required
          >
          <label
            for="name"
            class="form-label"
          >{{ $t('interior-advice.name') }} *</label>
        </div>

        <div class="relative mt-40">
          <input
            id="phone"
            type="text"
            class="form-input"
            name="message[Telefoonnummer]"
            :placeholder="`${$t('interior-advice.phone')} *`"
            required
          >
          <label
            for="phone"
            class="form-label"
          >{{ $t('interior-advice.phone') }} *</label>
        </div>

        <div class="relative mt-40">
          <input
            id="email"
            type="email"
            class="form-input"
            name="fromEmail"
            :placeholder="`${$t('interior-advice.email')} *`"
          >
          <label
            for="email"
            class="form-label"
          >{{ $t('interior-advice.email') }} *</label>
        </div>

        <div class="relative mt-40">
          <input
            id="message"
            type="text"
            class="form-input"
            name="message[Opmerking]"
            :placeholder="$t('offer.message')"
          >
          <label
            for="message"
            class="form-label"
          >{{ $t('offer.message') }}</label>
        </div>

        <button
          type="submit"
          :class="[loading ? 'bg-primary-700' : 'bg-primary-300']"
          class="flex w-full text-xl lg:text-2xl px-30 py-20 mt-50 items-center justify-center space-x-10 text-white font-serif font-bold hover:bg-primary-500 transition"
        >
          <img
            v-if="loading"
            src="@/assets/img/icon-loader.png"
            alt="loading..."
            class="w-[30px] h-[30px] animate-spin mr-10"
          >
          {{ loading ? $t('interior-advice.sending') : $t('interior-advice.send') }}
        </button>
      </div>
    </form>
  </aside>
</template>

<script setup>
import {
  ref,
  $fetch,
  useI18n,
  useNuxtApp,
} from '#imports';

// General icons
import closeIcon from '@/assets/img/icon-close.svg';

defineProps({
  modelValue: {
    type: Boolean,
  },
  product: {
    type: Object,
    required: true,
  },
  configuration: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  data: {
    type: Object,
    default: null,
  },
});

defineEmits([
  'update:modelValue',
]);

// Custom data
const { t } = useI18n();
const apiMessage = ref(null);
const loading = ref(null);
const { $gtm } = useNuxtApp();

// Methods
/**
 * Sends contact form data
 *
 * @param {Event} e
 */
const sendForm = async (e) => {
  apiMessage.value = null;
  const body = new FormData(e.target);
  loading.value = true;

  try {
    await $fetch('/', {
      method: 'POST',
      body,
    });

    e.target.reset();
    apiMessage.value = {
      error: false,
      errors: null,
      message: t('product.quote-submission-success'),
    };

    // GTM tracking
    $gtm.trackEvent({
      event: 'offerteaanvraag',
    });
  } catch (error) {
    apiMessage.value = {
      error: true,
      ...error.data,
    };
  } finally {
    loading.value = false;
  }
};
</script>
